import React, { useState, useRef } from "react";
import { FiHash, FiUsers, FiType, FiTag, FiAlignLeft, FiUser, FiList, FiLayers, FiMail, FiMapPin, FiMap, FiFileText, FiPhone, FiCalendar, FiEdit, FiDollarSign, FiRefreshCw, FiMessageCircle, FiSliders, FiPlus} from "react-icons/fi";
import { GoNote } from "react-icons/go";
import { BsBuildings } from "react-icons/bs";
import Input from "../../../../app/components/Input";
import Select from "../../../../app/components/Select";
import Button from "../../../../app/components/Button";
import SelectResponsible from "../../../../app/components/SelectResponsible";

const EditableField = ({ label, icon, initialValue, type = "input", options = [], onSave}) => {
  const mapInitialValue = (val) => {
    if(type === 'radios') {
      if(val === 'churn') return 'sim';
      if(val === 'não churn') return 'nao';
    }
    return val;
  };

  const [value, setValue] = useState(mapInitialValue(initialValue));
  const [tempValue, setTempValue] = useState(mapInitialValue(initialValue));
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef(null);

  const handleEdit = () => {
    setTempValue(value);
    setIsEditing(true);
    setTimeout(() => {
      inputRef.current?.focus?.();
    }, 0);
  };

  const handleCancel = () => {
    setTempValue(value);
    setIsEditing(false);
  };

  const handleSave = () => {
    setValue(tempValue);
    setIsEditing(false);
    if (onSave) {
      let valueToSave = tempValue;
    if(type === 'radios') {
      if(tempValue === 'sim') valueToSave = 'churn';
      else if(tempValue === 'nao') valueToSave = 'não churn';
    }
    onSave(valueToSave);
    }
  };

  const handleBlur = (e) => {
    if (
      e.relatedTarget &&
      (e.relatedTarget.id === "saveButton" || e.relatedTarget.id === "cancelButton")
    ) {
      return;
    }
    handleCancel();
  };


  return (
    <div className="mb-6">
      <div className="flex items-center gap-2">
        <div className="p-1">{icon}</div>
        <h2>{label}</h2>
      </div>

      {isEditing ? (
        <div className="mt-2">
          {type === "input" ? (
            <Input
              ref={inputRef}
              value={tempValue}
              onChange={(e) => setTempValue(e.target.value)}
              onBlur={handleBlur}
              className="h-10 text-sm"
            />
          ) : type === "select" ? (
            <Select
              ref={inputRef}
              value={tempValue}
              onChange={({ target: { value } }) => setTempValue(value)}
              onBlur={handleBlur}
              options={options}
              className=""
            />
          ) : type === "responsible" ? (
            <SelectResponsible
              label={'Responsável'}
              ref={inputRef}
              value={tempValue}
              onChange={setTempValue}
              options={options}
              onBlur={handleBlur}
            />)
            : type === "radios" ? (
              <div className="flex gap-2 ml-2">
                <div className="flex items-center gap-1">
                  <input
                      type="radio"
                      id="radioYes"
                      name="options"
                      value='sim'
                      className="appearance-none w-4 h-4 border-2 border-[#672c71] cursor-pointer rounded-full relative flex items-center justify-center bg-white checked:bg-white before:content-[''] before:w-2 before:h-2 before:rounded-full before:bg-[#672c71] before:scale-0 before:transition-transform checked:before:scale-100"
                      checked={tempValue === 'sim'}
                      onChange={(e) => setTempValue(e.target.value)}
                  />
                  <label htmlFor='radioYes' className="flex items-center cursor-pointer text-gray-700 gap-1">
                    <p>Sim</p>
                  </label>
                </div>
                <div className="flex items-center gap-1">
                  <input
                      type="radio"
                      id="radioNo"
                      name="options"
                      value='nao'
                      className="appearance-none w-4 h-4 border-2 border-[#672c71] cursor-pointer rounded-full relative flex items-center justify-center bg-white checked:bg-white before:content-[''] before:w-2 before:h-2 before:rounded-full before:bg-[#672c71] before:scale-0 before:transition-transform checked:before:scale-100"
                      checked={tempValue === 'nao'}
                      onChange={(e) => setTempValue(e.target.value)}
                  />
                  <label htmlFor='radioNo' className="flex items-center cursor-pointer text-gray-700 gap-1">
                    <p>Não</p>
                  </label>
                </div>
              </div>
          ) : null}

          <div className="flex gap-2 mt-2">
            <Button id="saveButton" onClick={handleSave} variant="primary">
              Salvar
            </Button>
            <Button id="cancelButton" onClick={handleCancel} variant="secondary">
              Cancelar
            </Button>
          </div>
        </div>
      ) : (
          <p
            onClick={handleEdit}
            title="Clique para editar"
            className="flex items-center mt-2 text-gray-400 justify-between font-normal cursor-pointer transition-color trasition duration-300 hover:text-gray-500"
          >
            {type === "responsible"
            ? (Array.isArray(value) ? value.join(", ") : value)
            : value}
            <FiEdit/>
          </p>
      )}
    </div>
  );
};

const RegisterClient = ({ empresa, handleFieldChange }) => {
  const e = empresa || {};

  return (
    <div className="p-6">
      <EditableField label="ID" icon={<FiHash />} initialValue={e.id || ""} />
      <EditableField
        label="CPF/CNPJ"
        icon={<GoNote />}
        initialValue={e.cnpj || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("cnpj", newValue)}
      />
      <EditableField
        label="Churn"
        icon={<BsBuildings />}
        type="radios"
        initialValue={e.churn || ""}
        onSave={(newValue) => handleFieldChange("churn", newValue)}
      />
      <EditableField
        label="Razão Social"
        icon={<BsBuildings />}
        initialValue={e.razaoSocial || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("razaoSocial", newValue)}
      />
      <EditableField
        label="Nome Fantasia"
        icon={<FiType />}
        initialValue={e.nomeFantasia || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("nomeFantasia", newValue)}
      />
      <EditableField
        label="Regime Tributário"
        icon={<FiTag />}
        type="select"
        options={[
          { label: "Simples Nacional", value: "Simples Nacional" },
          { label: "Lucro Presumido", value: "Lucro Presumido" },
          { label: "Lucro Real", value: "Lucro Real" },
        ]}
        initialValue={e.regimeTributario || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("regimeTributario", newValue)}
      />
      <EditableField
        label="Nome Leva Arquivo"
        icon={<FiAlignLeft />}
        initialValue={e.nomeLevaArquivo || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("levaArquivo", newValue)}
      />
      <EditableField
        label="Responsável"
        type="responsible"
        options={[
          { label: "Responsável 1", value: "Responsável 1" },
          { label: "Responsável 2", value: "Responsável 2" },
        ]}
        icon={<FiUser />}
        initialValue={e.responsavel || "Selecione responsavel"}
        onSave={(newValue) => handleFieldChange("responsavel", newValue)}
      />
      <EditableField
        label="Grupo Empresas"
        icon={<FiList />}
        initialValue={e.grupo || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("grupo", newValue)}
      />
      <EditableField
        label="Grupo Mensal"
        icon={<FiLayers />}
        initialValue={e.grupoMensal || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("grupoMensal", newValue)}
      />
      <EditableField
        label="Email"
        icon={<FiMail />}
        initialValue={e.email || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("email", newValue)}
      />
      <EditableField
        label="Endereço"
        icon={<FiMapPin />}
        initialValue={e.endereço || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("endereco", newValue)}
      />
      <EditableField
        label="Cep"
        icon={<FiMapPin />}
        initialValue={e.cep || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("cep", newValue)}
      />
      <EditableField
        label="Bairro"
        icon={<FiMapPin />}
        initialValue={e.bairro || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("bairro", newValue)}
      />
      <EditableField
        label="Cidade"
        icon={<FiMapPin />}
        initialValue={e.cidade || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("cidade", newValue)}
      />
      <EditableField
        label="Uf"
        icon={<FiMap />}
        initialValue={e.uf || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("uf", newValue)}
      />
        <EditableField
          label="Telefone"
          icon={<FiPhone />}
          initialValue={e.Telefone || "Clique aqui para adicionar"}
          onSave={(newValue) => handleFieldChange("telefone", newValue)}
        />
      <EditableField
        label="NIRE"
        icon={<FiFileText />}
        initialValue={e.nire || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("nire", newValue)}
      />
      <EditableField
        label="Inscrição Municipal"
        icon={<FiFileText />}
        initialValue={e.inscricaoMunicipal || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("inscricaoMunicipal", newValue)}
      />
      <EditableField
        label="Inscrição Estaduas"
        icon={<FiFileText />}
        initialValue={e.email || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("inscricaoEstadual", newValue)}
      />
      <EditableField
        label="Data IE"
        icon={<FiCalendar />}
        initialValue={e.dataIe || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("dataIe", newValue)}
      />
      <EditableField
        label="Isenta"
        icon={<FiDollarSign />}
        type="select"
        options={[
          { label: "Sim", value: "Sim" },
          { label: "Não", value: "Não" },
        ]}
        initialValue={e.isenta || "Clique aqui para selecionar"}
        onSave={(newValue) => handleFieldChange("isenta", newValue)}
      />
       <EditableField
        label="Tem movimento"
        icon={<FiRefreshCw />}
        type="select"
        options={[
          { label: "Sim", value: "Sim" },
          { label: "Não", value: "Não" },
        ]}
        initialValue={e.temMovimento || "Clique aqui para selecionar"}
        onSave={(newValue) => handleFieldChange("temMovimento", newValue)}
      />
      <EditableField
        label="Comentários"
        icon={<FiMessageCircle />}
        initialValue={e.comentarios || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("comentarios", newValue)}
      />
      <EditableField
        label="Números"
        icon={<FiSliders />}
        initialValue={e.numeros || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("numeros", newValue)}
      />
       <EditableField
        label="Complemento"
        icon={<FiPlus />}
        initialValue={e.complemento || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("complemento", newValue)}
      />
      <EditableField
        label="Cliente desde"
        icon={<FiCalendar />}
        initialValue={e.clienteDesde || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("clienteDesde", newValue)}
      />
      <EditableField
        label="Cliente até"
        icon={<FiCalendar />}
        initialValue={e.clienteAte || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("clienteAte", newValue)}
      />
      <EditableField
        label="Honorário mensal"
        icon={<FiDollarSign />}
        initialValue={e.honorarioMensal || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("horarioMensal", newValue)}
      />
      <EditableField
        label="Quantidade funcionários"
        icon={<FiUsers />}
        initialValue={e.quantidadeFuncionarios || "Clique aqui para adicionar"}
        onSave={(newValue) => handleFieldChange("quantiadadeFuncionarios", newValue)}
      />
    </div>
  );
};

export default RegisterClient;
